import React, { memo } from 'react'
import FirebaseUIAuth from 'react-firebaseui-localized'
import {
  useAuth,
  useFirebaseApp,
  useFirestore,
  useFirestoreCollectionData,
} from 'reactfire'

const FireChatAuth = memo(() => {
  const { firebase_ } = useFirebaseApp()
  const auth = useAuth

  const chatRef = useFirestore()
    .collection('chat')
    .orderBy('createdAt', 'desc')
    .limit(20)

  const chat = useFirestoreCollectionData(chatRef)

  return (
    <div className="chat-app">
      <div className="message-renderer">
        {chat.map(x => {
          return (
            <div className="message">
              <img
                src={x.picture ? x.picture : '/default-profile-picture.png'}
                alt="Foto de perfil"
              />
              <p uid={x.uid}>
                <strong>{x.name}:</strong> {x.message}
              </p>
            </div>
          )
        })}
      </div>
      <FirebaseUIAuth
        lang="es_419"
        config={{
          // Popup signin flow rather than redirect flow.
          signInFlow: 'popup',
          // We will display Google and Email as auth providers.
          signInOptions: [
            auth.GoogleAuthProvider.PROVIDER_ID,
            auth.FacebookAuthProvider.PROVIDER_ID,
            auth.EmailAuthProvider.PROVIDER_ID,
          ],
        }}
        auth={auth()}
        firebase={firebase_}
      />
      <center>
        <h2
          style={{
            backgroundColor: '#2196F3',
            borderRadius: '25px',
            padding: '0.75rem',
            width: 'fit-content',
            color: '#f1f3f5',
          }}
        >
          Ingresa con tu cuenta para poder enviar mensajes en el chat.
        </h2>
      </center>
    </div>
  )
})

export default FireChatAuth
